module.exports = __webpack_public_path__ + "images/psp/CarStorage/car-storage-hero.webp";